/*
|--------------------------------------------------------------------------
| MODULUP CONFIGURATOR
|--------------------------------------------------------------------------
*/

const app = document.querySelector('.modulup-configurator .mc-app');

if (!app) {
  throw new Error('Configurator app not found');
}

/*
|--------------------------------------------------------------------------
| STATE
|--------------------------------------------------------------------------
*/

let currentStep = 0;

const selections = {
  category: null,
  model: null,
  arm: null,
  minder: null
};

const steps = [
  'Kategorini Belirle',
  'Boyut Seç',
  'Kolçak Tipi',
  'Minder Stili'
];

/*
|--------------------------------------------------------------------------
| HELPERS
|--------------------------------------------------------------------------
*/

function createHandles(productCode, armCode, fabric = 'mikro-kadife') {
  return {
    fitilli: `chillax-${productCode}-fitilli-${armCode}-${fabric}`,
    dikisli: `chillax-${productCode}-dikisli-${armCode}-${fabric}`
  };
}

function createVariant(productCode, armCode, size) {
  return {
    productCode,
    size,
    handles: createHandles(productCode, armCode)
  };
}

function getSelectedVariant() {
  if (!selections.model || !selections.arm) return null;

  return selections.model.variants[selections.arm.code] || null;
}

function getVariantKeys(model) {
  return Object.keys(model?.variants || {});
}

function modelHasSingleArm(model) {
  return getVariantKeys(model).length === 1;
}

/*
|--------------------------------------------------------------------------
| DATA
|--------------------------------------------------------------------------
*/

const CATEGORIES = [
  {
    code: 'modul',
    name: 'Tekli & Loveseat & İkili & Üçlü',
    description: 'Bağımsız Kullanımlı Koltuklar',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Ikili_Okaliptus_Yesili.jpg?v=1784720761'
  },
  {
    code: 'uzanmali_kose',
    name: 'Uzanmalı Köşe',
    description: 'Uzanmalı Köşe Modelleri',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/OY-_Midi_Kose.jpg?v=1778767328'
  },
  {
    code: 'l_kose',
    name: 'L Köşe',
    description: 'L Köşe Kombinasyonları',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/OY-_Mini_L_Kose.jpg?v=1778767328'
  }
];

const ARM_OPTIONS = [
  {
    code: 'tiny-miny',
    name: 'Tiny Miny',
    description: '4cm(Sol)+4cm(Sağ) Toplam 8cm',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Tiny_Miny.jpg?v=1779454139'
  },
  {
    code: 'iskandinav',
    name: 'İskandinav',
    description: '15cm(Sol)+15cm(Sağ) Toplam 30cm',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Iskandinav.jpg?v=1779454139'
  },
  {
    code: 'post-modern',
    name: 'Post Modern',
    description: '16cm(Sol)+16cm(Sağ) Toplam 32cm',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Post_Modern.jpg?v=1779454138'
  },
  {
    code: 'italyan',
    name: 'İtalyan',
    description: '22cm(Sol)+22cm(Sağ) Toplam 44cm',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Italyan.jpg?v=1779454139'
  }
];

const L_KOSE_MODELS = [
  ['214-x-214-l-kose', 'tiny-miny', '214 x 214', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/TM.jpg?v=1783584611'],
  ['225-x-225-l-kose', 'iskandinav', '225 x 225', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/lovkoslovisk.jpg?v=1779718545'],
  ['226-x-226-l-kose', 'post-modern', '226 x 226', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/lovkoslovpm.jpg?v=1779718545'],
  ['232-x-232-l-kose', 'italyan', '232 x 232', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/lovekoslovit.jpg?v=1779718545'],
  ['264-x-214-l-kose', 'tiny-miny', '264 x 214', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/TM_bb9280f2-4d18-4486-9490-4e74ef4ceab4.jpg?v=1783584669'],
  ['264-x-264-l-kose', 'tiny-miny', '264 x 264', ''],
  ['275-x-225-l-kose', 'iskandinav', '275 x 225', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoseloveisk.jpg?v=1779718712'],
  ['275-x-275-l-kose', 'iskandinav', '275 x 275', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoseikiliisk.jpg?v=1779718916'],
  ['276-x-226-l-kose', 'post-modern', '276 x 226', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoselovepm.jpg?v=1779718713'],
  ['276-x-276-l-kose', 'post-modern', '276 x 276', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoseikilipm.jpg?v=1779718984'],
  ['282-x-232-l-kose', 'italyan', '282 x 232', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoseloveit.jpg?v=1779718712'],
  ['282-x-282-l-kose', 'italyan', '282 x 282', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikilikoseikiliit.jpg?v=1779719089'],
  ['294-x-214-l-kose', 'tiny-miny', '294 x 214', ''],
  ['294-x-264-l-kose', 'tiny-miny', '294 x 264', ''],
  ['294-x-294-l-kose', 'tiny-miny', '294 x 294', ''],
  ['305-x-225-l-kose', 'iskandinav', '305 x 225', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/uclukoselovisk.jpg?v=1779719190'],
  ['305-x-275-l-kose', 'iskandinav', '305 x 275', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_I_ISK.jpg?v=1783584785'],
  ['305-x-305-l-kose', 'iskandinav', '305 x 305', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_U_ISK.jpg?v=1783584820'],
  ['306-x-226-l-kose', 'post-modern', '306 x 226', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/PM.jpg?v=1783584909'],
  ['306-x-276-l-kose', 'post-modern', '306 x 276', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_I_PM.jpg?v=1783584952'],
  ['306-x-306-l-kose', 'post-modern', '306 x 306', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_U_PM.jpg?v=1783584983'],
  ['312-x-232-l-kose', 'italyan', '312 x 232', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ITL.jpg?v=1783585023'],
  ['312-x-282-l-kose', 'italyan', '312 x 282', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_I_ITL.jpg?v=1783585060'],
  ['312-x-312-l-kose', 'italyan', '312 x 312', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/U_K_U_ITL.jpg?v=1783585089'],
  ['344-x-214-l-kose', 'tiny-miny', '344 x 214', ''],
  ['344-x-264-l-kose', 'tiny-miny', '344 x 264', ''],
  ['355-x-225-l-kose', 'iskandinav', '355 x 225', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_L_ISK_b6baee9d-3999-4585-b114-1cbf7099f8ad.jpg?v=1783585393'],
  ['355-x-275-l-kose', 'iskandinav', '355 x 275', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_I_ISK.jpg?v=1783585423'],
  ['356-x-226-l-kose', 'post-modern', '356 x 226', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_L_PM_6d4cde40-b27d-4d92-8b75-e3c91fcf9fac.jpg?v=1783585472'],
  ['356-x-276-l-kose', 'post-modern', '356 x 276', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_I_PM.jpg?v=1783585498'],
  ['362-x-232-l-kose', 'italyan', '362 x 232', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_L_ITL_631757b5-9d78-4558-91b1-6c43fc58a272.jpg?v=1783585551'],
  ['362-x-282-l-kose', 'italyan', '362 x 282', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_I_K_I_ITL.jpg?v=1783585649'],
  ['374-x-214-l-kose', 'tiny-miny', '374 x 214', ''],
  ['374-x-264-l-kose', 'tiny-miny', '374 x 264', ''],
  ['374-x-294-l-kose', 'tiny-miny', '374 x 294', ''],
  ['385-x-225-l-kose', 'iskandinav', '385 x 225', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_L_ISK.jpg?v=1783585847'],
  ['385-x-275-l-kose', 'iskandinav', '385 x 275', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_I_ISK.jpg?v=1783585876'],
  ['385-x-305-l-kose', 'iskandinav', '385 x 305', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_U_ISK.jpg?v=1783585904'],
  ['386-x-226-l-kose', 'post-modern', '386 x 226', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_L_PM.jpg?v=1783585939'],
  ['386-x-276-l-kose', 'post-modern', '386 x 276', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_I_PM.jpg?v=1783585966'],
  ['386-x-306-l-kose', 'post-modern', '386 x 306', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_U_PM.jpg?v=1783585977'],
  ['392-x-232-l-kose', 'italyan', '392 x 232', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_L_ITL.jpg?v=1783586012'],
  ['392-x-282-l-kose', 'italyan', '392 x 282', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_I_ITL.jpg?v=1783586025'],
  ['392-x-312-l-kose', 'italyan', '392 x 312', 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/D_U_K_U_ITL.jpg?v=1783586039']
].filter(([, armCode]) => armCode !== 'tiny-miny').sort((a, b) => {
  const firstSizeA = Number(a[0].split('-x-')[0]);
  const firstSizeB = Number(b[0].split('-x-')[0]);
  const secondSizeA = Number(a[0].split('-x-')[1]);
  const secondSizeB = Number(b[0].split('-x-')[1]);

  return firstSizeA - firstSizeB || secondSizeA - secondSizeB;
}).map(([productCode, armCode, size, img]) => {
  const arm = ARM_OPTIONS.find(item => item.code === armCode);

  return {
    code: productCode,
    category: 'l_kose',
    name: `${size} L Köşe`,
    description: `Kol Çeşidi: ${arm ? arm.name : armCode}`,
    variants: {
      [armCode]: createVariant(productCode, armCode, size)
    },
    img: img || ''
  };
});

const MODELS = [
  {
    code: 'tekli',
    category: 'modul',
    name: 'Tekli',
    description: 'Tekli Modül (Kolsuz oturum ölçüsü: 65cm)',
    variants: {
      'tiny-miny': createVariant('tekli', 'tiny-miny'),
      iskandinav: createVariant('tekli', 'iskandinav'),
      'post-modern': createVariant('tekli', 'post-modern'),
      italyan: createVariant('tekli', 'italyan')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Tekli.jpg?v=1778596710'
  },
  {
    code: 'loveseat',
    category: 'modul',
    name: 'Loveseat',
    description: 'Loveseat Modül (Kolsuz oturum ölçüsü: 100cm)',
    variants: {
      'tiny-miny': createVariant('loveseat', 'tiny-miny'),
      iskandinav: createVariant('loveseat', 'iskandinav'),
      'post-modern': createVariant('loveseat', 'post-modern'),
      italyan: createVariant('loveseat', 'italyan')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Loveseat.jpg?v=1778596711'
  },
  {
    code: 'ikili',
    category: 'modul',
    name: 'İkili',
    description: 'İkili Modül (Kolsuz oturum ölçüsü: 150cm)',
    variants: {
      'tiny-miny': createVariant('ikili', 'tiny-miny'),
      iskandinav: createVariant('ikili', 'iskandinav'),
      'post-modern': createVariant('ikili', 'post-modern'),
      italyan: createVariant('ikili', 'italyan')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Ikili.jpg?v=1778596710'
  },
  {
    code: 'uclu',
    category: 'modul',
    name: 'Üçlü',
    description: 'Üçlü Modül (Kolsuz oturum ölçüsü: 180cm)',
    variants: {
      'tiny-miny': createVariant('uclu', 'tiny-miny'),
      iskandinav: createVariant('uclu', 'iskandinav'),
      'post-modern': createVariant('uclu', 'post-modern'),
      italyan: createVariant('uclu', 'italyan')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/Uclu.jpg?v=1778600212'
  },

  {
    code: 'dinlenme-tekli',
    category: 'uzanmali_kose',
    name: 'Dinlenme + Tekli',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('153-x-170-kose', 'tiny-miny', '153 x 170'),
      iskandinav: createVariant('175-x-170-kose', 'iskandinav', '175 x 170'),
      'post-modern': createVariant('177-x-170-kose', 'post-modern', '177 x 170'),
      italyan: createVariant('189-x-170-kose', 'italyan', '189 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/tekliisk.jpg?v=1778935971'
  },
  {
    code: 'dinlenme-loveseat',
    category: 'uzanmali_kose',
    name: 'Dinlenme + Loveseat',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('188-x-170-kose', 'tiny-miny', '188 x 170'),
      iskandinav: createVariant('210-x-170-kose', 'iskandinav', '210 x 170'),
      'post-modern': createVariant('212-x-170-kose', 'post-modern', '212 x 170'),
      italyan: createVariant('224-x-170-kose', 'italyan', '224 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/loveseatisk.jpg?v=1778935965'
  },
  {
    code: 'dinlenme-tekli-tekli',
    category: 'uzanmali_kose',
    name: 'Dinlenme + Tekli + Tekli',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('218-x-170-kose', 'tiny-miny', '218 x 170'),
      iskandinav: createVariant('240-x-170-kose', 'iskandinav', '240 x 170'),
      'post-modern': createVariant('242-x-170-kose', 'post-modern', '242 x 170'),
      italyan: createVariant('254-x-170-kose', 'italyan', '254 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/teklitekliisk.jpg?v=1778935971'
  },
  {
    code: 'dinlenme-ikili',
    category: 'uzanmali_kose',
    name: 'Dinlenme + İkili',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('238-x-170-kose', 'tiny-miny', '238 x 170'),
      iskandinav: createVariant('260-x-170-kose', 'iskandinav', '260 x 170'),
      'post-modern': createVariant('262-x-170-kose', 'post-modern', '262 x 170'),
      italyan: createVariant('274-x-170-kose', 'italyan', '274 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ikiliisk.jpg?v=1778935970'
  },
  {
    code: 'dinlenme-uclu',
    category: 'uzanmali_kose',
    name: 'Dinlenme + Üçlü',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('266-x-170-kose', 'tiny-miny', '266 x 170'),
      iskandinav: createVariant('290-x-170-kose', 'iskandinav', '290 x 170'),
      'post-modern': createVariant('292-x-170-kose', 'post-modern', '292 x 170'),
      italyan: createVariant('304-x-170-kose', 'italyan', '304 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/ucluiskandinav.jpg?v=1778935971'
  },
  {
    code: 'dinlenme-loveseat-loveseat',
    category: 'uzanmali_kose',
    name: 'Dinlenme + Loveseat + Loveseat',
    description: 'Kolçak seçimine göre ölçü değişir',
    variants: {
      'tiny-miny': createVariant('290-x-170-kose', 'tiny-miny', '290 x 170'),
      iskandinav: createVariant('310-x-170-kose', 'iskandinav', '310 x 170'),
      'post-modern': createVariant('312-x-170-kose', 'post-modern', '312 x 170'),
      italyan: createVariant('326-x-170-kose', 'italyan', '326 x 170')
    },
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/loveseatloveseatisk.jpg?v=1778935971'
  },

  ...L_KOSE_MODELS
];

const MINDER_OPTIONS = [
  {
    code: 'fitilli',
    name: 'Fitilli',
    description: 'Fitilli Minder',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/WhatsApp_Image_2026-05-14_at_16.21.19_1.jpg?v=1778764949'
  },
  {
    code: 'dikisli',
    name: 'Dikişli',
    description: 'Dikişli Minder',
    img: 'https://cdn.shopify.com/s/files/1/0718/5321/1830/files/WhatsApp_Image_2026-05-14_at_16.21.19.jpg?v=1778764949'
  }
];

/*
|--------------------------------------------------------------------------
| RENDER
|--------------------------------------------------------------------------
*/

function render() {
  app.innerHTML = `
    ${renderProgress()}
    ${renderBackButton()}
    ${renderCurrentStep()}
  `;
}

function renderProgress() {
  return "" /* `
    <div class="mc-progress">
      ${steps.map((step, index) => `
        <div class="mc-step ${index === currentStep ? 'active' : ''}">
          ${step}
        </div>
      `).join('')}
    </div>
  ` */;
}

function renderBackButton() {
  if (currentStep === 0) return '';

  return `
    <button class="mc-button" style="margin-bottom:30px;" onclick="goBack()">
      ← Geri
    </button>
  `;
}

function renderCurrentStep() {
  if (currentStep === 0) {
    return renderCards(
      'Kendi Koltuğunu Tasarla, 30 Gün İçinde Kapına Gelsin',
      '',
      CATEGORIES,
      'category'
    );
  }

  if (currentStep === 1) {
    const models = MODELS.filter(
      item => item.category === selections.category.code
    );

    return renderCards(
      '',
      '',
      models,
      'model'
    );
  }

  if (currentStep === 2) {
    return renderCards(
      '',
      '',
      getAvailableArmOptions(),
      'arm'
    );
  }

  return renderCards(
    '',
    '',
    MINDER_OPTIONS,
    'minder'
  );
}

function renderCards(title, subtitle, items, key) {
  return `
    <h1 class="mc-title">
      ${title}
    </h1>

    <p class="mc-subtitle">
      ${subtitle}
    </p>

    ${renderSummary()}

    <div class="mc-grid">
      ${items.map(item => `
        <div class="mc-card" onclick="selectItem('${key}', '${item.code}')">
          <div class="mc-image">
            <img
              src="${item.img || 'https://placehold.co/600x400/F5F0E8/C4856A?text=Gorsel+Hazirlaniyor'}"
              alt="${item.name}"
            >
          </div>

          <div class="mc-body">
            <div class="mc-name">
              ${item.name}
            </div>

            <div class="mc-detail">
              ${item.description}
            </div>
          </div>
        </div>
      `).join('')}
    </div>
  `;
}

function renderSummary() {
  const items = [
    ['Kategori', selections.category],
    ['Model', selections.model],
    ['Kolçak', selections.arm],
    ['Minder', selections.minder]
  ].filter(item => item[1]);

  const variant = getSelectedVariant();

  if (variant?.size) {
    items.push(['Ölçü', { name: variant.size }]);
  }

  if (!items.length) return '';

  return "" /* `
    <div class="mc-summary">
      ${items.map(([label, value]) => `
        <div class="mc-summary-item">
          <div class="mc-summary-label">
            ${label}
          </div>

          <div class="mc-summary-value">
            ${value.name}
          </div>
        </div>
      `).join('')}
    </div>
  ` */;
}

function getAvailableArmOptions() {
  if (!selections.model) return [];

  return ARM_OPTIONS
    .filter(item => selections.model.variants[item.code])
    .map(item => {
      const variant = selections.model.variants[item.code];

      return {
        ...item,
        description: variant.size
          ? `${item.description} (${variant.size} cm)`
          : item.description
      };
    });
}

/*
|--------------------------------------------------------------------------
| ACTIONS
|--------------------------------------------------------------------------
*/

function selectItem(key, code) {
  const map = {
    category: CATEGORIES,
    model: MODELS,
    arm: getAvailableArmOptions(),
    minder: MINDER_OPTIONS
  };

  selections[key] = map[key].find(item => item.code === code);

  if (!selections[key]) {
    console.error('Selection not found', { key, code });
    return;
  }

  if (key === 'category') {
    selections.model = null;
    selections.arm = null;
    selections.minder = null;
  }

  if (key === 'model') {
    selections.arm = null;
    selections.minder = null;

    if (modelHasSingleArm(selections.model)) {
      const armCode = getVariantKeys(selections.model)[0];
      selections.arm = ARM_OPTIONS.find(item => item.code === armCode);
      currentStep += 2;

      render();

      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });

      return;
    }
  }

  if (key === 'arm') {
    selections.minder = null;
  }

  if (key === 'minder') {
    const productUrl = buildProductUrl();

    if (productUrl === '#') return;

    window.location.href = productUrl;
    return;
  }

  currentStep++;

  render();

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

function goBack() {
  currentStep = Math.max(currentStep - 1, 0);

  if (currentStep === 2 && modelHasSingleArm(selections.model)) {
    currentStep = 1;
    selections.model = null;
    selections.arm = null;
    selections.minder = null;
  }

  if (currentStep === 0) {
    selections.category = null;
    selections.model = null;
    selections.arm = null;
    selections.minder = null;
  }

  if (currentStep === 1) {
    selections.model = null;
    selections.arm = null;
    selections.minder = null;
  }

  if (currentStep === 2) {
    selections.arm = null;
    selections.minder = null;
  }

  render();

  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
}

/*
|--------------------------------------------------------------------------
| PRODUCT URL
|--------------------------------------------------------------------------
*/

function buildProductUrl() {
  const variant = getSelectedVariant();

  if (!variant || !selections.minder) {
    console.error('Missing product selection', selections);
    return '#';
  }

  const handle = variant.handles[selections.minder.code];

  if (!handle) {
    console.error('Product handle not found', selections);
    return '#';
  }

  return `/products/${handle}`;
}

/*
|--------------------------------------------------------------------------
| INIT
|--------------------------------------------------------------------------
*/

window.selectItem = selectItem;
window.goBack = goBack;

render();
